import store from 'store'

class InitConfig {
  initConfiguration () {
    let req = new XMLHttpRequest()
    req.open('GET', document.location, false)
    req.send(null)
    let headers = req.getAllResponseHeaders()
    let arr = headers.trim().split(/[\r\n]+/)
    let headerMap = {}
    let configurationFromHeader = {}
    arr.forEach(function (line) {
      let parts = line.split(': ')
      let header = parts.shift()
      let value = parts.join(': ')
      headerMap[header] = value
    })

    if (!headerMap.hasOwnProperty('x_dds_label')) {
      configurationFromHeader.x_dds_label = 'ddcrm'
    } else {
      configurationFromHeader.x_dds_label = headerMap.x_dds_label
    }

    if (!headerMap.hasOwnProperty('x_dds_language')) {
      configurationFromHeader.x_dds_language = 'it-IT'
    } else {
      configurationFromHeader.x_dds_language = headerMap.x_dds_language
    }

    if (!headerMap.hasOwnProperty('x_dds_selfcare')) {
      configurationFromHeader.x_dds_selfcare = '0'
    } else {
      configurationFromHeader.x_dds_selfcare = headerMap.x_dds_selfcare
    }

    store.dispatch('themes/switchTheme', configurationFromHeader.x_dds_label)
    store.dispatch('i18n/setLocale', configurationFromHeader.x_dds_language)
    return configurationFromHeader
  }
}

export default new InitConfig()
